/* unplugin-vue-components disabled */import script from "./AgeLimit.vue?vue&type=script&setup=true&lang=js"
export * from "./AgeLimit.vue?vue&type=script&setup=true&lang=js"

import "./AgeLimit.vue?vue&type=style&index=0&id=00cd8ac7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cd8ac7"]])

export default __exports__